import layout from '@modules/layouts/redux';
import auth from '@modules/login/redux';
import register from '@modules/register/redux';
import invites from '@modules/corporate-invite/redux';
import helpdesk from '@modules/helpdesk/redux';
import entity from '@modules/entity/redux';
import corporate from '@modules/corporate/redux';
import calcEngine from '@modules/calculate-engine/redux';
import activity from '@modules/activity/redux';
import reports from '@modules/reports/redux';
import validators from '@modules/validators/redux';
import dashboard from '@modules/dashboard/redux';

export default {
  layout,
  auth,
  register,
  invites,
  helpdesk,
  entity,
  corporate,
  calcEngine,
  activity,
  reports,
  validators,
  dashboard,
};
